import { useProjectListingSuggestionState } from '../use-project-listing-suggestion.state';

import { EnhanceProjectCompleteView } from '../results/enhance-project-complete-view';
import { EnhanceProjectErrorView } from '../results/enhance-project-error-view';
import { EnhanceProjectLoadingView } from '../results/enhance-project-loading-view';

export const AnalyzingView = () => {
  const state = useProjectListingSuggestionState();

  if (state.currentPageStep === 'error') {
    return <EnhanceProjectErrorView />;
  }

  if (state.currentPageStep === 'results') {
    return <EnhanceProjectCompleteView data={state.enhanceResults} />;
  }

  if (state.currentPageStep === 'analyzing') {
    return <EnhanceProjectLoadingView />;
  }

  return null;
};
